"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.settings.general': 'General',
    'route.settings.styles': 'Styles',
    'route.settings.access': 'Access',
    'route.settings.accessEdit': 'Edit Access',
    'route.settings.accessAdd': 'Add Access',
    'route.settings.socialMediaPlan': 'Brands & Team',
    'route.settings.whatsapp': 'WhatsApp',
    'route.settings.whatsapp.manage': 'Manage WhatsApp Number',
    'route.settings.whatsappSettings': 'WhatsApp Numbers',
    'route.settings.whatsappSettings.create': 'Add WhatsApp Number',
    'route.settings.whatsappSettings.edit': 'Edit WhatsApp Number',
};
